import { render, staticRenderFns } from "./AltUserEmailModal.vue?vue&type=template&id=5afb2cbc"
import script from "./AltUserEmailModal.vue?vue&type=script&lang=js"
export * from "./AltUserEmailModal.vue?vue&type=script&lang=js"
import style0 from "./AltUserEmailModal.vue?vue&type=style&index=0&id=5afb2cbc&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5afb2cbc')) {
      api.createRecord('5afb2cbc', component.options)
    } else {
      api.reload('5afb2cbc', component.options)
    }
    module.hot.accept("./AltUserEmailModal.vue?vue&type=template&id=5afb2cbc", function () {
      api.rerender('5afb2cbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Utility/AltUserEmailModal.vue"
export default component.exports